// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_guU","cls2":"ExportFormatModal-cls2_Wtc ExportFormatModal-cls1_guU"};